import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import React from 'react'

const elementPropertiesStyles = makeStyles((theme: Theme) => ({
    autoCompleteMargin: {
        '& .MuiFormControl-marginNormal': {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
        '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    autoCompletePopper: {
        '& .MuiAutocomplete-listbox': {
            overflowWrap: 'anywhere',
        },
        marginLeft: pxToRem(1),
    },
    inputText: {
        fontSize: pxToRem(14),
        paddingLeft: 10,
    },
}))

interface AutoCompleteElementPropertiesProps {
    dropdownList: string[]
    parameterName: string
    placeholderText: string
    selectedValue: string | null
    handleChange?: (paramName: string, paramVal: string | null) => void
    isDisabled: boolean
    name?: string
    customizedStyle?: string
}
const AutoCompleteElementProperties: React.FC<AutoCompleteElementPropertiesProps> = ({
    dropdownList,
    parameterName,
    placeholderText,
    selectedValue,
    handleChange,
    isDisabled,
    name,
    customizedStyle,
}) => {
    const classes = elementPropertiesStyles()
    return (
        <Autocomplete
            disabled={isDisabled}
            className={clsx(
                classes.autoCompleteMargin,
                customizedStyle && customizedStyle
            )}
            data-testid={
                name ? `autoCompleteInput${name}` : 'autoCompleteInput'
            }
            options={dropdownList}
            classes={{ popper: classes.autoCompletePopper }}
            value={selectedValue}
            onChange={(_: React.ChangeEvent<{}>, inputValue: string | null) => {
                handleChange?.(parameterName, inputValue)
            }}
            renderInput={(params) => (
                <TextField
                    name={parameterName}
                    {...params}
                    margin="normal"
                    variant="outlined"
                    placeholder={placeholderText}
                    inputProps={{
                        ...params.inputProps,
                        'aria-autocomplete': 'none',
                        autoComplete: 'chrome-off',
                        className: classes.inputText,
                        form: {
                            autocomplete: 'off',
                        },
                        'aria-label': parameterName,
                    }}
                />
            )}
            ListboxProps={{
                style: {
                    maxHeight: '250px',
                },
            }}
        />
    )
}

export default AutoCompleteElementProperties
